// Maps productId (or order type) to the list of required action keys (steps)
export const ORDER_STEPS: Record<string, string[]> = {
  // Photo Family Tree (Basic Layout)
  "pft-basic-layout": ["FamilyTree", "Photos"],
  // Photo Family Tree (Custom Layout)
  "pft-custom-layout": ["FamilyTree", "Photos"],
  // Missionary Photo Art
  "mpa-art": ["Missionary", "Photos"],
  // Generational Art (Circular Layout)
  "ga-circular": ["Generational"],
  // Generational Art (Horizontal Layout)
  "ga-horizontal": ["Generational"],
  // Gift Certificates
  "gc-basic-family-photo-tree": ["FamilyTree"],
  "gc-custom-family-photo-tree": ["FamilyTree"],
  "gc-missionary-photo-art": ["Missionary"],
  // Add more as needed for other product types
};

// Maps action keys to their corresponding URLs/routes
export const ORDER_ACTION_URLS: Record<string, string> = {
  FamilyTree: "/account?tab=family-tree",
  Photos: "/account?tab=family-tree", // Photos are uploaded in the family tree tab
  Missionary: "/account?tab=missionary-form",
  // Generational: "/account/generational",
  // Add more as needed for other action types
};

/**
 * Order Options Format Documentation:
 * 
 * For generation-based products, the selectedOptions.generations field should be:
 * - Type: number (integer)
 * - Examples: 2, 3, 4, 5
 * - Meaning: Number of generations to include in the product
 * 
 * This is used for:
 * - Family Tree products (pft-*)
 * - Generational Art products (ga-*)
 * - Gift Certificate family tree products (gc-*)
 */
